import {
    AttachmentsAction,
    deleteAttachmentAction,
    replaceAttachmentAction,
    uploadAttachmentAction,
} from 'aos-services/src/core/attachments/actions'
import { AttachmentsState } from 'aos-services/src/core/attachments/state'
import { acceptString } from 'aos-services/src/services/attachments/types/AttachmentType'
import { AttachmentGrid } from 'aos-ui-universal'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface TaskAttachmentGridProps {
    attachmentsState: AttachmentsState
    attachmentsAction(a: AttachmentsAction): void
}

export const TaskAttachmentGrid = ({
    attachmentsState,
    attachmentsAction,
}: TaskAttachmentGridProps) => {
    const { t } = useTranslation()

    return (
        <AttachmentGrid
            attachments={attachmentsState.attachments}
            isUploading={attachmentsState.isUploading}
            hint={`(${t('allowed-file-types', { ns: 'events' })})`}
            accept={acceptString}
            onUpload={files => attachmentsAction(uploadAttachmentAction(files))}
            onRemove={attachment => attachmentsAction(deleteAttachmentAction(attachment))}
            onReplace={payload => attachmentsAction(replaceAttachmentAction(payload))}
        />
    )
}
